module.exports = __webpack_public_path__ + "img/50d.0ae04678.png";